export const MobileCodeRouting = {
  path: "/mobileCode",
  name: "mobileCode",
  meta: { title: "验证手机号" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/mobile-code/index.vue"),
  children: [],
};
